import { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormInputText } from '@hopskipdrive/react-components';
import { LockRounded } from '@mui/icons-material';
import { Button } from '@rideiq/shared/components/Button';
import { PageHeading } from '@rideiq/shared/components/PageHeading';
import { FormA11yErrorAnnouncer } from '@rideiq/shared/features/FormA11yErrorAnnouncer';
import { AnyObjectSchema } from 'yup';

import { Container, StyledAction } from './styles';

export interface ChangePasswordFormProps {
  handleChangePassword: (data, e) => void;
  validationSchema?: AnyObjectSchema;
}

type FormData = {
  password: string;
  password_confirmation: string;
};

export const ChangePasswordForm: FC<ChangePasswordFormProps> = ({ handleChangePassword, validationSchema }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    ...(validationSchema && { resolver: yupResolver(validationSchema) }),
    shouldUnregister: true,
  });

  return (
    <Container>
      <PageHeading variant="h1">Change password</PageHeading>
      <form className="form" onSubmit={handleSubmit(handleChangePassword)}>
        <FormA11yErrorAnnouncer errors={errors} />
        <Controller
          name="password"
          control={control}
          render={({ field: { value, onChange } }) => (
            <FormInputText
              id="password"
              value={value}
              inputProps={{
                'data-testid': 'password',
              }}
              placeholder="New password"
              type="password"
              variant="outlined"
              icon={<LockRounded />}
              error={!!errors.password}
              autoFocus
              fullWidth
              helperText={errors.password ? errors.password.message : ''}
              onChange={onChange}
            />
          )}
        />
        <Controller
          name="password_confirmation"
          control={control}
          render={({ field: { value, onChange } }) => (
            <FormInputText
              id="password_confirmation"
              value={value}
              inputProps={{
                'data-testid': 'password_confirmation',
              }}
              placeholder="Confirm new password"
              type="password"
              variant="outlined"
              icon={<LockRounded />}
              error={!!errors.password_confirmation}
              autoFocus
              fullWidth
              helperText={errors.password_confirmation ? errors.password_confirmation.message : ''}
              onChange={onChange}
            />
          )}
        />

        <StyledAction>
          <Button type="submit" data-testid="submitButton" color="primary">
            Change Password
          </Button>
        </StyledAction>
      </form>
    </Container>
  );
};
